import { useMemo } from 'react'
import { HookRouter } from 'src/types/router'
import { NavigateOptions, useNavigate } from 'react-router-dom'

export function useRouter(): HookRouter {
  const navigate = useNavigate()

  const router = useMemo(
    () => ({
      goBack: () => navigate(-1),
      forward: () => navigate(1),
      reload: () => window.location.reload(),
      push: (href: string, options?: NavigateOptions) =>
        navigate(href, options),
      replace: (href: string) => navigate(href, { replace: true }),
    }),
    [navigate]
  )

  return router
}
